export const planPartoRoutes = (apiBase) => ({
  planParto: `${apiBase}/plan-parto`,
  planPartoHistorico: (unicId) => `${apiBase}/plan-parto/historico?Unic_ID=${encodeURIComponent(unicId)}`,
  planPartoDetalle: (idPlanParto) => `${apiBase}/plan-parto/detalle?id_plan_parto=${idPlanParto}`,
});
